
export const AUTH_TYPE_COGNITO = 'cognito';
export const AUTH_TYPE_OKTA = 'okta';